import { memo } from "react";
import { addHours } from "date-fns/addHours";
import { EventsByDateWithLayout } from "../../types";
import { getZonedDayStart } from "../../utils";
import { ActiveDayColumnDrag, DayEventsColumn } from "../CalendarDayView";

export interface WeekViewHourGridProps {
  startDate: Date;
  daysOfWeek: string[];
  eventsByDate: EventsByDateWithLayout;
  onTimeClick: (time: number) => void;
  onCreateRange: (startTimestamp: number, durationMinutes: number) => void;
  activeDrag: ActiveDayColumnDrag | null;
  timezone: string;
  dayStartMinutes: number;
  dayEndMinutes: number;
  userIds?: string[];
  showAvailability?: boolean;
}

const WeekViewHourGridInner = ({
  startDate,
  daysOfWeek,
  eventsByDate,
  onTimeClick,
  onCreateRange,
  activeDrag,
  timezone,
  dayStartMinutes,
  dayEndMinutes,
  userIds,
  showAvailability,
}: WeekViewHourGridProps) => {
  return (
    <>
      {daysOfWeek.map((day, dayIndex) => {
        const dayStartDate = getZonedDayStart(addHours(startDate, dayIndex * 24 + 1), timezone);
        return (
          <DayEventsColumn
            key={`${day}-column`}
            droppableId={`week-day-${dayIndex}`}
            droppableData={{ dayIndex }}
            dayStartDate={dayStartDate}
            events={eventsByDate[dayStartDate.getTime()]}
            onTimeClick={onTimeClick}
            onCreateRange={onCreateRange}
            activeDrag={activeDrag}
            timezone={timezone}
            dayStartMinutes={dayStartMinutes}
            dayEndMinutes={dayEndMinutes}
            userIds={userIds}
            showAvailability={showAvailability}
          />
        );
      })}
    </>
  );
};

export const WeekViewHourGrid = memo(WeekViewHourGridInner);
